import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HeaderComponent } from './view/header/header.component';
import {MatIconModule} from '@angular/material/icon';
import { HttpClientModule } from '@angular/common/http';
import { HomeComponent } from './view/home/home.component';
import { ShowcaseComponent } from './view/home/showcase/showcase.component';
import { SharedModule } from './modules/shared/shared.module';
import { SliderComponent } from './view/home/slider/slider.component';
import { AboutUsComponent } from './view/home/about-us/about-us.component';
import { TestimonialComponent } from './view/home/testimonial/testimonial.component';
import { CreativeComponent } from './view/home/creative/creative.component';
import { FooterComponent } from './view/footer/footer.component';
import { MapComponent } from './view/footer/map/map.component';
import { SlideComponent } from './view/header/slide/slide.component';
import { AchievementComponent } from './view/home/achievement/achievement.component';
import { AboutModule } from './modules/about/about.module';
import { InfrastructureModule } from './modules/infrastructure/infrastructure.module';
import { BeyondModule } from './modules/beyond/beyond.module';
import { AwardModule } from './modules/award/award.module';
import { TinyModule } from './modules/tiny/tiny.module';
import { AdmissionComponent } from './view/admission/admission.component';
import { AngularFireModule } from 'angularfire2';
import { environment } from 'src/environments/environment';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAnalyticsModule } from '@angular/fire/analytics';
import { GalleryModule } from './modules/gallery/gallery.module';
import { ContactModule } from './modules/contact/contact.module';
import { BlogsModule } from './modules/blogs/blogs.module';
import { MandatoryModule } from './modules/mandatory/mandatory.module';
import { StaffModule } from './modules/staff/staff.module';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    ShowcaseComponent,
    SliderComponent,
    AboutUsComponent,
    TestimonialComponent,
    CreativeComponent,
    FooterComponent,
    MapComponent,
    SlideComponent,
    AchievementComponent,
    AdmissionComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatIconModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAnalyticsModule,
    HttpClientModule,
    SharedModule,
    AboutModule,
    InfrastructureModule,
    BeyondModule,
    AwardModule,
    TinyModule,
    GalleryModule,
    ContactModule,
    BlogsModule,
    MandatoryModule,
    StaffModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
